module.exports = __webpack_public_path__ + "static/media/main-view.4213ce21.png";